import _ from 'lodash';
import Vue from 'vue';

const startCase = val => _.startCase(val);

Vue.filter('startCase', startCase);
